/**
 * @author lifei
 * 功能：提示框
 * @param content 提示框内容组件或文本
 * @param title 标题
 * @param extParams ant 参数
 */
import { type VNode, h } from 'vue'
import { Modal, type ModalFuncProps } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { isObject, isString } from 'lodash-es'

type TExcludeTypeList = 'content' | 'onOk'
type TExtParams = Omit<ModalFuncProps, TExcludeTypeList>

export const confirm = (content: string | VNode, title?: string | TExtParams): Promise<void> => {
  return new Promise((resolve, reject) => {
    const options = {
      content,
      icon: h(ExclamationCircleOutlined),
      onOk: () => resolve(),
      onCancel: () => reject(),
      title: '温馨提示',
    }
    if (isString(title)) {
      options.title = title
    } else if (isObject(title)) {
      Object.assign(options, title)
    }
    Modal.confirm(options)
  })
}
